export const debounce = (func, wait) => {
  let timeout

  return function (...args) {
    const later = () => {
      timeout = null
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}
